// extracted by mini-css-extract-plugin
module.exports = {"main":"login-page_main__3oyDL","form":"login-page_form__2zTTD","nav":"login-page_nav__QCwgJ","link":"login-page_link__kpw7J"};